import * as Actions from "./constants";
import { put, call, takeEvery, all } from "redux-saga/effects";
import {
  generateCoupon,
  getCouponBundle,
  getCouponByBundle,
  editBundle,
  deleteBundle,
  updateBundle,
  deleteCoupon,
  editCoupon,
  updateCoupon,
  resendEmail
} from "./service";
/**
 * Generate Coupon
 */
function* generateCoupons({ postData }) {
  try {
    const { data } = yield call(generateCoupon, postData);
    yield put({
      type: Actions.GENERATE_COUPON_SUCCESS,
      payload: data,
    });
  } catch (error) {
    yield put({
      type: Actions.GENERATE_COUPON_ERROR,
      error: error,
    });
  }
}
/**
 * List coupon bundle
 */
function* listCouponBundle({ limit }) {
  try {
    const { data } = yield call(getCouponBundle, limit);
    yield put({
      type: Actions.GET_COUPON_BUNDLE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    yield put({
      type: Actions.GET_COUPON_BUNDLE_ERROR,
      error: error,
    });
  }
}

/**
 * list coupons with bundle id
 */
function* listCouponsByBundleID(bundleID, exported) {
  try {
    const { data } = yield call(getCouponByBundle, bundleID, exported);
    yield put({
      type: Actions.GET_COUPON_BY_BUNDLE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    yield put({
      type: Actions.GET_COUPON_BY_BUNDLE_ERROR,
      error: error,
    });
  }
}

/**
 * Delete Bundle
 */
function* deleteBundleData(id) {
  try {
    const { data } = yield call(deleteBundle, id);
    yield put({
      type: Actions.DELETE_BUNDLE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    yield put({
      type: Actions.DELETE_BUNDLE_ERROR,
      error: error,
    });
  }
}

/**
 * Delete Coupon
 */
function* deleteCouponData(id, postData) {
  try {
    const { data } = yield call(deleteCoupon, id, postData);
    yield put({
      type: Actions.DELETE_COUPON_SUCCESS,
      payload: data,
    });
  } catch (error) {
    yield put({
      type: Actions.DELETE_COUPON_ERROR,
      error: error,
    });
  }
}

/**
 * Edit Bundle
 */
function* editBundleData(id) {
  try {
    const { data } = yield call(editBundle, id);
    yield put({
      type: Actions.EDIT_BUNDLE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    yield put({
      type: Actions.EDIT_BUNDLE_ERROR,
      error: error,
    });
  }
}

/**
 * Edit Coupon
 */
function* editCouponData(id) {
  try {
    const { data } = yield call(editCoupon, id);
    yield put({
      type: Actions.EDIT_COUPON_SUCCESS,
      payload: data,
    });
  } catch (error) {
    yield put({
      type: Actions.EDIT_COUPON_ERROR,
      error: error,
    });
  }
}

/**
 * Update Bundle
 */
function* updateBundleData({ postData }) {
  try {
    const { data } = yield call(updateBundle, postData);
    yield put({
      type: Actions.UPDATE_BUNDLE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    yield put({
      type: Actions.UPDATE_BUNDLE_ERROR,
      error: error,
    });
  }
}

/**
 * Update Coupon
 */
function* updateCouponData({ postData }) {
  try {
    const { data } = yield call(updateCoupon, postData);
    yield put({
      type: Actions.UPDATE_COUPON_SUCCESS,
      payload: data,
    });
  } catch (error) {
    yield put({
      type: Actions.UPDATE_COUPON_ERROR,
      error: error,
    });
  }
}

/**
 * Send Email
 */
function* sendCouponEmail(id) {
  try {
    const { data } = yield call(resendEmail, id);
    yield put({
      type: Actions.COUPON_RESEND_EMAIL_SUCCESS,
      payload: data,
    });
  } catch (error) {
    yield put({
      type: Actions.COUPON_RESEND_EMAIL_ERROR,
      error: error,
    });
  }
}

export default function* couponSaga() {
  yield takeEvery(Actions.GENERATE_COUPON, generateCoupons);
  yield takeEvery(Actions.GET_COUPON_BUNDLE, listCouponBundle);
  yield takeEvery(Actions.GET_COUPON_BY_BUNDLE, listCouponsByBundleID);
  yield takeEvery(Actions.DELETE_BUNDLE, deleteBundleData);
  yield takeEvery(Actions.EDIT_BUNDLE, editBundleData);
  yield takeEvery(Actions.UPDATE_BUNDLE, updateBundleData);
  yield takeEvery(Actions.DELETE_COUPON, deleteCouponData);
  yield takeEvery(Actions.EDIT_COUPON, editCouponData);
  yield takeEvery(Actions.UPDATE_COUPON, updateCouponData);
  yield takeEvery(Actions.COUPON_RESEND_EMAIL, sendCouponEmail);
}
